import React, {useContext} from "react";
import {FormUIConfig, FormUIConfigContext} from "./formUIContext";
import { GlobalStateContext } from '../../context/GlobalStateProvider';

import {merge} from "lodash";

export function FormConfiguration({children, ...props}: {
  children: any,
  props: FormUIConfig
}) {

  const cfg = useContext(FormUIConfigContext);
  const { isDesktop} = useContext(GlobalStateContext);

  if (!isDesktop && props.controlMobile) {
    props = {...props, control:props.controlMobile}
  }

  if (!isDesktop && props.labelMobile) {
    props = {...props, label:props.labelMobile}
  }

  if (!isDesktop && props.rowMobile) {
    props = {...props, row:props.rowMobile}
  }

  const newCfg = merge({}, cfg, props);

  return <FormUIConfigContext.Provider value={newCfg}>
    {children}
  </FormUIConfigContext.Provider>
}